
























































import { defineComponent, ref } from "@vue/composition-api";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { app } from "@/store/index";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./Sensors/SensorHeader.vue"),
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./Dialogs/ConfirmDialog.vue"),
    },
    setup() {
        const { contacts, getContacts, update } = useContact({ autoLoadContacts: true });
        const showStatus = ref<boolean>(false);
        const statusTitle = ref<string>("Update failed");
        const statusMessage = ref<string>("Could not update the contact.");

        const handleStatus = (status: number) => {
            if (status === 200) {
                return true;
            }

            if (status === 403) {
                statusTitle.value = "Not allowed";
                statusMessage.value = "Only the captain can change contacts for this device.";
            } else if (status === 409) {
                statusTitle.value = "Duplicate email";
                statusMessage.value = "This email already exists for this device or belongs to a captain.";
            } else {
                statusTitle.value = "Update failed";
                statusMessage.value = "Could not update the contact. Please try again.";
            }

            showStatus.value = true;
            return false;
        };

        const toggleActive = (contact: ContactViewModel) => {
            // at this point, contact.active has already been set by v-model
            console.log("Switch is now:", contact.active);

            update(contact)
                .then((status) => {
                    if (handleStatus(status)) {
                        getContacts();
                    } else {
                        contact.active = !contact.active;
                    }
                })
                .catch(err => {
                    console.error("Update failed:", err);
                    contact.active = !contact.active;
                });
        };

        return {
            contacts,
            toggleActive,
            showStatus,
            statusTitle,
            statusMessage,
        };
    },
});
